module.exports = __webpack_public_path__ + "assets/img/8_1723_big.e2d8b8fd.jpg";